import React from 'react';
import { Icon } from './Icon.js';
export const IconNamePlate = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 7L22 9L22 15L20 17L4 17L2 15L2 9L4 7L20 7Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M11 12.0048L7 12.0048", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M17 12L15 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconNamePlate.js.map